import { getBuddyUserByID } from '@adornis/bh-matching-user/api/MatchingUserAPI.js';
import { loadMongoData } from '@adornis/baseql/server/data-loader.js';
import { selectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { readEntitiesByIDs } from '@adornis/bh-util/server/entity-reads.js';
import { getMenteeUserClass } from '@adornis/bh-matching-user/user-class.js';
import { defineMailTemplate } from '@adornis/mails/db/mail-template-definition.js';
import { BuddyMailAttachment } from '../entities/attachment.js';
import {
  BuddyMailTemplate,
  convertUserToMailVarObject,
  getMenteeFields,
  MailTemplateType,
} from '../entities/mail-templates.js';
import { localAttachmentPath } from '../mails/attachment-local-path.js';

export function registerRegistrationMentee() {
  return defineMailTemplate(MailTemplateType.REGISTRATION_MENTEE, {
    getMailData: async (menteeID: string) => {
      const user = await getBuddyUserByID(
        getMenteeUserClass()._class,
        menteeID,
      )(selectionSet(() => getMenteeUserClass(), 2));
      if (!user) throw new Error('Mentee user(' + getMenteeUserClass()._class + ') not found: ' + menteeID);
      const data = convertUserToMailVarObject(user as any);

      // attachments
      const mailTemplate = await loadMongoData(BuddyMailTemplate, {
        emailType: MailTemplateType.REGISTRATION_MENTEE,
      }).then(res => res?.[0]);
      if (!mailTemplate) throw new Error('No mail template found for type ' + MailTemplateType.REGISTRATION_MENTEE);

      const attachments = {};
      const attachmentData = await readEntitiesByIDs(
        BuddyMailAttachment,
        mailTemplate.activatedAttachments,
        selectionSet(() => BuddyMailAttachment, 2),
      );
      for (const attachment of attachmentData) {
        attachments[attachment._id] = await localAttachmentPath(attachment);
      }

      return { data, attachments, scope: 'default' };
    },
    defaultTemplate: {
      subject: `Herzlich willkommen bei GROW@Goethe Mentoring (SoSe 2024): Deine Anmeldung/Registrierung`,
      content: `<p>Hallo {{firstName}},<br></p>
<p> vielen Dank für Deine Anmeldung für das Mentoring-Programm GROW@Goethe.&nbsp;Die Anmeldefrist für die Mentees endet am 18. April. Direkt im Anschluss findet das Matching statt. Bis zum 22. April erhältst Du eine Zu- oder Absage zum Mentoring-Programm per Mail.</p><p>Hinweis: Bei einer Zusage erhältst Du die Einladung zum verpflichtenden Vorbereitungsseminar, welches am 27.04.24 in Präsenz am Campus Westend stattfindet, per Mail (prüfe bitte regelmäßig Deine Mails/Spam-Ordner).</p><p>Falls Du Fragen hast, wende Dich gerne an uns: <a href="mailto:mentoring@uni-frankfurt.de">mentoring@uni-frankfurt.de</a>.<br></p>
<p> Wir freuen uns, Dich bald kennenzulernen. </p>
<p> Viele Grüße, </p>
<p> Dein Mentoring-Team</p>`,
      footer: '',
    },
    variables: getMenteeFields(),
    attachments: [],
    displayName: 'Registrierung: Mentee',
    editorHint: () => 'Diese Mail wird automatisch nach erfolgreicher Registrierung an den Mentee versendet.',
  });
}
